import React, { useState, memo } from 'react';
const RestaurantFAQ = () => {
  const faqs = [{
    question: 'How does SmartSoda improve the dining experience?',
    answer: 'SmartSoda enhances your dining experience by offering premium craft beverages made with premium clean label ingredients that complement your food menu. These unique beverage options create a memorable impression and give guests another reason to choose your restaurant.'
  }, {
    question: 'How does SmartSoda support restaurant sustainability goals?',
    answer: 'Our AI-powered dispensers eliminate single-use plastics and packaging waste by providing unlimited on-demand beverages, significantly reducing your environmental footprint and appealing to eco-conscious diners.'
  }, {
    question: 'Is SmartSoda cost-effective for restaurants?',
    answer: 'Absolutely! SmartSoda increases profit margins on beverages to 60%+, eliminates storage costs for bottles and cans, reduces labor for inventory management, and streamlines operations – creating significant financial benefits.'
  }, {
    question: 'What types of beverages are available for restaurants?',
    answer: 'SmartSoda offers a wide selection, including craft sodas, flavored waters, sparkling waters, teas, lemonades, sports drinks, and cold brews—with customizable carbonation levels and flavor intensity to complement your menu.'
  }, {
    question: 'How does the automated inventory system work?',
    answer: 'Our connected platform tracks usage in real-time and automatically notifies our service team when refills are needed—keeping your system stocked without any effort from your staff, eliminating stockouts during busy service times.'
  }, {
    question: 'Can we create signature house beverages?',
    answer: 'Yes! Our culinary team can work with you to develop custom flavor profiles exclusive to your restaurant, creating signature beverages that enhance your brand identity and menu offerings.'
  }, {
    question: 'How much space does a SmartSoda dispenser require?',
    answer: 'Our machines are compact and space-saving, replacing bulky cases of bottled drinks and freeing up valuable storage and refrigeration space in your restaurant.'
  }, {
    question: "What's required for installation?",
    answer: 'SmartSoda dispensers connect to your existing water source and power supply, making installation quick and hassle-free. Our professional technicians handle the entire setup process with minimal disruption to your operations.'
  }, {
    question: 'Do you provide staff training?',
    answer: 'Yes! We provide comprehensive training for your staff on system operation, maintenance, and how to suggest and serve SmartSoda beverages to enhance the guest experience and increase check averages.'
  }, {
    question: 'How can I get started?',
    answer: 'Contact us today to schedule a consultation and bring SmartSoda to your restaurant! We’ll work with you to design a beverage program that complements your menu and enhances your dining experience.'
  }];
  const [openIndex, setOpenIndex] = useState(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section className="py-20 bg-gray-50" id="faq" data-id="element-1065">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1066">
        <div className="text-center mb-16" data-id="element-1067">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-1068">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-1069">
            Everything you need to know about SmartSoda for your restaurant
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden" data-id="element-1070">
          {faqs.map((faq, index) => <div key={index} className="border-b border-gray-100 last:border-b-0" data-id="element-1071">
              <button className="w-full px-6 py-5 text-left focus:outline-none" onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index} data-id="element-1072">
                <div className="flex justify-between items-center" data-id="element-1073">
                  <h3 className="text-lg font-medium text-navy-950" data-id="element-1074">
                    {faq.question}
                  </h3>
                  <span className="ml-6 flex-shrink-0" data-id="element-1075">
                    <svg className={`h-6 w-6 transform ${openIndex === index ? 'rotate-180' : 'rotate-0'} transition-transform duration-200 ease-in-out text-gray-500`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1076">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-1077" />
                    </svg>
                  </span>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'}`} data-id="element-1078">
                <div className="px-6 text-gray-600" data-id="element-1079">{faq.answer}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default RestaurantFAQ;